<template>
  <modal title="Collect Payment" width="35" :showModal="showModal" @close-modal="closeModal">
    <!-- <div class="w-full text-primary-yellow py-2">View Bill</div> -->
    <!-- Start of collect payment form -->
    <div class="pt-4 b-btm" v-for="(item, index) in collectForm" :key="index">
      <div class="individual-contaoner">
        <label class="label">Amount Due (NGN)</label>
        <input v-model="item.amount_due" :disabled="true" placeholder="--Autoloaded--"
          class="input-field w-full py-2 pl-3 cursor-not-allowed text-gray-600" />
      </div>

      <div class="individual-contaoner">
        <label class="label">Amount Paid (NGN)</label>
        <input v-model="item.amount_paid" @input="setPaymentStatus($event, index)" placeholder="--Enter Amount--"
          class="input-field w-full py-2 pl-3" />
      </div>

      <div class="individual-contaoner">
        <label class="label">Payment Type </label>
        <el-select class="input-field" filterable @change="checkPayment($event, index)" v-model="item.payment_type"
          placeholder="Tranfer Or POS">
          <el-option v-for="payment in paymenttypes" :key="payment" :label="payment" :value="payment">
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner" v-if="item.passivePayment">
        <label class="label">Receiving Account / Bank </label>
        <el-select class="input-field" filterable v-model="item.bank" placeholder="Select Account">
          <el-option v-for="payment in banks" :key="payment.id"
            :label="payment.bank_name + ' (' + payment.account_number + ')'" :value="payment.bank_name">
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">Note</label>
        <textarea placeholder="Text Area" v-model="item.note" @input="checkTextlength($event, index)"
          class="input-field w-full h-32 resize-none p-3"></textarea>
        <span class="w-full text-right block">{{ item.note.length }}/300</span>
      </div>
    </div>
    <!-- End of collect payment form -->

    <!-- <div class="py-5">
      <span class="text-red-600 text-base cursor-pointer" @click="addAnother"
        >Add Another</span
      >
    </div> -->

    <div class="flex items-center justify-between border-b-2 border-t-2 border-gray-600 py-4">
      <span class="w-full block">Payment Type :
        <span v-for="item in collectForm" :key="item.payment_type" class="w-full block">{{ item.payment_type }}</span>
      </span>
      <span class="w-full block px-2">Amount : N{{ totalCost }}</span>
      <span class="w-full block">Balance Due : (N) {{ totalCost - totalPayValue }}</span>
    </div>

    <div class="actions flex items-center justify-end cursor-pointer mt-20">
      <div>
        <primary-button class="shadow-md" buttonText="Confirm Payment" :loading="loading" @click="onPayment" />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>
    </div>
    <PaymentModal @close-modal="showPaymentModal = false" :show-modal="showPaymentModal" :total="cardPaymentAmount"
      :paystackkey="paystackkey" @onCardPayment="onCardPayment" />
  </modal>
</template>

<script>
import PaymentModal from "./PaymentModal.vue";

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    totalCost: {
      type: Number,
      required: true,
      default: 0
    },
    transactionId: {},
    shippingId: {},
  },
  components: {
    PaymentModal,
  },
  computed: {
    canSubmit() {
      return this.amount_paid != "" && this.paymentType != "";
    },
    payload() {
      return {
        userId: localStorage.getItem("userId"),
        orgId: localStorage.getItem("organizationId"),
        transactions: [...this.collectForm],
      };
    },
  },
  watch: {
    totalCost() {
      this.collectForm.forEach((element, index) => {
        this.collectForm[index].amount_due = this.totalCost;
        this.collectForm[index].shipping_id = this.shippingId;
        this.collectForm[index].productId = this.shippingId;
      });
    },
  },
  mounted() {
    this.getAllBanks();
    this.collectForm.map((item) => {
      return { ...item, amount_due: this.totalCost, amount_paid: this.totalCost };
    });
  },
  data() {
    return {
      collectForm: [
        {
          status: this.status,
          totalValue: this.totalCost,
          amount_due: this.totalCost,
          passivePayment: false,
          productId: this.shipping_id,
          amount_paid: this.totalCost,
          payment_type: "",
          shipping_id: this.shipping_id,
          bank: "",
          note: "",
          paymentStatus: "",
          breakDown: {
            vat: 0,
            insuranceFee: 0,
            handlingCharges: 0,
          },
        },
      ],
      banks: [],
      totalPayValue: 0,
      totalPaymentType: [],
      cardPaymentAmount: 0,
      cardTransactionIndex: null,
      paymenttypes: ["Cash", "POS", "Transfer", "Charge Wallet", "Charge Card"],
      loading: false,
      status: "pending",
      showPaymentModal: false,
      isPaystacksuccess: false,
      paystackkey: "pk_test_d81d41eedf44bac3067b59281f5aec31efc13049",
    };
  },

  methods: {
    setPaymentStatus(val, index) {
      this.collectForm[index].paymentStatus =
        this.collectForm[index].amount_paid >=
          this.collectForm[index].amount_due
          ? "paid"
          : "partial";
      this.totalPayValue = 0;
      this.totalPayValue = this.collectForm
        .map((item) => item.amount_paid)
        .reduce((prev, next) => Number(prev) + Number(next));
    },
    async getAllBanks() {
      const response = await this.$_getBanks({});
      this.banks = response.data.data?.accounts || [];
    },
    checkPayment(val, index) {
      if (val == "POS" || val == "Transfer") {
        this.collectForm[index].passivePayment = true;
      } else {
        this.collectForm[index].passivePayment = false;
      }
      this.totalPaymentType = this.collectForm.map((item) => item.payment_type);
      this.cardPaymentAmount = this.collectForm[index].amount_due;
      this.cardTransactionIndex = index;

      if (val == "Charge Card") {
        this.showPaymentModal = true;
        return;
      }
    },
    addAnother() {
      this.collectForm.push({
        status: this.status,
        totalValue: this.totalCost,
        amount_due: this.totalCost,
        passivePayment: false,
        productId: this.shipping_id,
        amount_paid: "",
        payment_type: "",
        shipping_id: "",
        bank: "",
        note: "",
        paymentStatus: "",
        breakDown: {
          vat: 0,
          insuranceFee: 0,
          handlingCharges: 0,
        },
      });
    },
    onCardPayment(val) {
      this.status = val;
      this.isPaystacksuccess = true;
      this.collectForm[this.cardTransactionIndex].status = "paid";

      setTimeout(() => {
        this.onPayment();
      }, 1000);
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async onPayment() {
      this.loading = true;
      try {
        await this.$_collectPayment(this.payload);
        this.changeStatus();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async changeStatus() {
      let payload = {
        paymentStatus: "paid",
        payment_type: this.collectForm[0].payment_type.toLowerCase(),
        userType: "private",
        userId: localStorage.getItem("userId"),
        productId: this.productId,
        amount_paid: this.collectForm[0].amount_paid,
      }
      try {
        const response = await this.$_updateTransactionStatus(payload, this.transactionId);

        this.$emit("refetch-transactions")
        console.log(JSON.stringify(response, null, 2));

        this.closeModal();

      } catch (error) {
        this.handleError(error);
      }
    },
    checkTextlength(event, index) {
      let value = event.target.value;
      if (this.collectForm[index].note.length > 300) {
        this.collectForm[index].note = value.substring(0, 300);
        return;
      }
      this.note = value;
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  @apply w-full pb-0;
  font-size: 13px;
}

.individual-contaoner {
  @apply w-full p-2 my-0;
}

.filter-search {
  border-radius: 4px;
  @apply py-2;
}

.input-field {
  @apply bg-gray-200;
}

.b-btm {
  border-bottom: 1px solid rgb(192, 178, 178);
}

.b-btm:nth-of-type(1) {
  border: none !important;
}
</style>
